import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 数据保持新鲜的时间，1分钟内不会重新请求
      gcTime: 1000 * 60 * 5, // 缓存保留时间，5分钟后清除未使用的缓存
      retry: 1, // 请求失败后重试次数
      refetchOnWindowFocus: false, // 窗口重新获得焦点时不自动刷新
    },
    mutations: {
      retry: 0, // 修改操作失败后不重试（避免重复操作）
    },
  },
});
